import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  languages,
  selectedLanguage,
} from '../../shared/components/header/elements/languages/languages.component';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/auth-api/user.service';
import { SignInRequest } from '../../services/auth-api/requests';
import {JwtUtils} from '../../shared/utils/jwt.utils';
import { BaseResponseError } from '../../services/models/base.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  public newUser = false;
  // public user: firebase.User;
  public loginForm: FormGroup;
  public show: boolean = false;
  public errorMessage: any;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    public router: Router,
    private translate: TranslateService,
    private toastrService: ToastrService,
    private userService: UserService
  ) {
    let lang =
      languages.find(
        (x) =>
          x.code.includes(navigator.language) ||
          navigator.language.includes(x.code)
      ) || selectedLanguage;
    this.translate.use(lang.code);

    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  ngOnInit() {
    let singInReponse = localStorage.getItem("singInReponse") && localStorage.getItem("singInReponse") != null
    ? JSON.parse(localStorage.getItem("singInReponse") ?? '')
    : undefined;

    if (singInReponse
    && !JwtUtils.isTokenExpired(singInReponse.accessToken)) {
      this.router.navigate(['']);
    }
  }

  login() {
    if (this.loginForm.valid) {
      this.loading = true;
      this.userService
        .signIn(
          new SignInRequest(
            this.loginForm.controls.email.value,
            this.loginForm.controls.password.value
          )
        )
        .subscribe({
          next: ({ data }) => {
            this.loading = false;
            localStorage.setItem(
              'singInReponse',
              JSON.stringify({
                accessToken: data.accessToken,
                expiresInSeconds: data.expiresInSeconds,
                refreshToken: data.refreshToken,
                refreshTokenExpiresInSeconds: data.refreshTokenExpiresInSeconds,
              })
            );
            localStorage.setItem('user', JSON.stringify(data.user));
            this.router.navigate(['/chat']);
          },
          error: (error) => {
            this.loading = false;
            console.error(error);
            if (error.error?.errors) {
              (error.error.errors as Array<BaseResponseError>)?.map(({ message }) => {
                this.toastrService.error(message, '', {
                  closeButton: true,
                  enableHtml: true,
                  positionClass: 'toast-top-right',
                });
              });
            }
          },
        });
    }
  }

  showPassword() {
    this.show = !this.show;
  }
}
